import { useEffect, useState } from 'react'
import { Separator } from '@design-systems/canvas-ui'
import VettingsStep from './VettingStep'
import { RFI_TYPE_LOCATION } from '../../common/commonConstants'

const VettingTimeline = (props) => {
  const [auditTrail, setAuditTrail] = useState([])

  useEffect(() => {
    setAuditTrail(props.auditTrail || [])
  }, [props.auditTrail])

  const isLocation = props.vettingType === RFI_TYPE_LOCATION

  return (
    <div
      id="div-vetting-timeline"
      className={`vetting-timeline ${
        isLocation ? 'vetting-timeline--location' : 'vetting-timeline--supplier'
      }`}
    >
      <div
        id={`div-vetting-timeline-${props.index}`}
        key={`div-vetting-timeline-${props.index}`}
        className="cursor-default vetting-timeline-track"
      >
        {auditTrail.map((eachAudit, stepIndex) => (
          <div
            className="vetting-timeline-segment"
            key={`div-audit-trail-${stepIndex}`}
          >
            <VettingsStep
              vettingType={props.vettingType}
              supplierId={props.supplierId}
              locationId={props.locationId}
              manufacturingTypeId={props.manufacturingTypeId}
              auditStepDetails={eachAudit}
              index={stepIndex}
            />

            {stepIndex !== auditTrail.length - 1 && (
              <Separator className="hc8-mh-none vetting-timeline-divider" />
            )}
          </div>
        ))}
      </div>
    </div>
  )
}

export default VettingTimeline
